import { DeleteOutlined, DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import * as React from "react";
import { KeyedImgFrame } from "src/business/attribute/attrEdits/AttrExternalImages/KeyedImgFrame";
import { ImagePreview } from "src/components/ImagePreview";
import {
  ActivateCallback,
  useActivateCallback,
} from "src/types/ActivateCallback";

import * as styles from "./ImagesListEditor.module.less";

type PropsImagesListEditor = {
  disabled?: boolean;
  items: KeyedImgFrame[];
  onRemove?(index: number): void;
  onOpen(): void;
  activateCallback?: ActivateCallback;
};

export const ImagesListEditor: React.FC<PropsImagesListEditor> = (props) => {
  const { disabled, items, onRemove, onOpen, activateCallback } = props;

  const ref: React.Ref<HTMLButtonElement> = useActivateCallback(
    activateCallback,
    (button) => () => {
      setTimeout(() => {
        button?.focus();
      }, 100);
    },
  );

  return (
    <button className={styles.box} ref={ref} tabIndex={-1} type="button">
      {items.length === 0 ? (
        <div className={styles.empty}>Нет изображений</div>
      ) : (
        items.map(({ key, url, label, downloadUrl }, i) => (
          <div key={key} className={styles.item}>
            <div className={styles.img}>
              <ImagePreview
                maxWidth="100%"
                maxHeight="100%"
                frames={items}
                startIndex={i}
              />
            </div>
            <div className={styles.name}>{label || decodeURI(url)}</div>
            {!!downloadUrl && (
              <Button
                href={downloadUrl}
                target="_blank"
                icon={<DownloadOutlined />}
                type="text"
              />
            )}
            {!disabled && onRemove && (
              <div className={styles.del}>
                <Button
                  icon={<DeleteOutlined />}
                  type="text"
                  title="Удалить"
                  onClick={() => onRemove(i)}
                />
              </div>
            )}
          </div>
        ))
      )}
      {!disabled && (
        <Button size="small" onClick={onOpen} color="blue" variant="solid">
          Изменить
        </Button>
      )}
    </button>
  );
};
